module.exports = __webpack_public_path__ + "static/scale-model-of-lincoln-nebraska-02eed14d6628a113ac1137e5e3d57bae.png";